import { createAppSlice } from '../../app/createAppSlice'

const initialState = {on: false};

const triggerRefreshSlice = createAppSlice({
    name: "triggerRefresh",
    initialState,
    reducers: create => ({
        triggerRefreshOn: create.reducer((state) => { state.on = true; }),
        triggerRefreshOff: create.reducer((state) => { state.on = false; }),
    }),
    selectors: {
        selectTriggerRefresh: triggerRefresh => triggerRefresh.on
    },
})

export const { triggerRefreshOn, triggerRefreshOff } = triggerRefreshSlice.actions

export const { selectTriggerRefresh } = triggerRefreshSlice.selectors

export default triggerRefreshSlice